import React  from 'react'
import CartItems from '../Components/CartItem/CartItems'


const Cart = () => {
 
  return (
    <div>
      <CartItems />
    </div>
  )
}

export default Cart
